import { render, staticRenderFns } from "./ReplyTopPanel.vue?vue&type=template&id=3f3a1454&scoped=true&"
import script from "./ReplyTopPanel.vue?vue&type=script&lang=js&"
export * from "./ReplyTopPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReplyTopPanel.vue?vue&type=style&index=0&id=3f3a1454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a1454",
  null
  
)

export default component.exports